//This is the cookie name used in unified.
export const STATE_OF_RESIDENCE_COOKIE_KEY: string = 'userSelectedState';
